import { DateRage } from "components/HeroSearchForm/type";

const convertSelectedDateToString = ([startDate, endDate]: DateRage) => {

  const locale = new Intl.Locale(navigator.language || "en-US");

  const dateString =
    (startDate?.toLocaleDateString(locale, {
      month: "short",
      day: "2-digit",
    }) || "") +
    (endDate
      ? " - " +
        endDate?.toLocaleDateString(locale, {
          month: "short",
          day: "2-digit",
        })
      : "");
  return dateString;
};

export default convertSelectedDateToString;
